import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/ExpandMore.jsx